import { endlessPaginate } from "endless_pagination/endless-pagination-module.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	endlessPaginate({
		moreSelector: "span.endless_more",
		moreSelectorDataUrl: "data-more",
	});

	if (document.querySelectorAll(".jarallax").length > 0) {
		import("jarallax").then(({ jarallax }) => {
			jarallax(document.querySelectorAll(".jarallax"), {
				speed: 0.8,
			});
		});
	}

	// BOOKMARKS
	const tag_container = document.querySelector("#_tag_container");
	if (tag_container?.dataset.ct && tag_container?.dataset.id) {
		fetch(
			`/misc/bookmarks_and_vote/${tag_container.dataset.ct}/${tag_container.dataset.id}/`,
			{
				headers: {
					"X-Requested-With": "XMLHttpRequest",
				},
				cache: "no-cache",
			},
		)
			.then((response) => response.json())
			.then((data) => {
				document.querySelector("#_tag_bookmarks").innerHTML =
					data.follow_bookmark_form;
				init_tag_bookmarks();
			})
			.catch((error) => {
				console.warn(error);
			});
	}
});

function init_tag_bookmarks() {
	import("../../common/bookmark.js").then(({ MpBookmark }) => {
		const tag_follow = new MpBookmark(
			document.querySelector("#_tag_bookmarks"),
			{
				form: document.querySelector("#_tag_bookmarks .bookmarks_form"),
				message: document.querySelector("#_tag_bookmarks .tab_label"),
				message_on: "Non seguire",
				message_off: "Segui",
			},
		);
	});
}
